module.exports = __webpack_public_path__ + "static/media/pdm.32ca68ea.png";